import { render } from "./VLoader.vue?vue&type=template&id=639e1d2e"
const script = {}

import exportComponent from "/tmp/build_4ea0b76e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__